import React from "react"

import {AppCrudTable} from "@components"
import {userSettingCategoryData} from "../../../@signals"
import {actionsColumn, colorColumn, nameColumn} from "./columns"
import { isTourDemoActive } from "@signals/app"

export default function UserSettingsCategoryTable() {
	if (isTourDemoActive.value && !userSettingCategoryData.value?.length) return null
    return <AppCrudTable
		title="Your Category Colors"
		data={userSettingCategoryData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}